// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","switcher":"switcher-NB1T4","switcher_alternative":"switcher_alternative-16gNW"};